module.exports = {
        srcSet: "/_next/static/images/foam-finger@3x-42-acb32e4ed3a79db2.png"+" 42w"+","+"/_next/static/images/foam-finger@3x-84-4ae4fef71d43480a.png"+" 84w"+","+"/_next/static/images/foam-finger@3x-126-e8d5d84edb5b1248.png"+" 126w",
        images: [{path: "/_next/static/images/foam-finger@3x-42-acb32e4ed3a79db2.png",width: 42,height: 57},{path: "/_next/static/images/foam-finger@3x-84-4ae4fef71d43480a.png",width: 84,height: 114},{path: "/_next/static/images/foam-finger@3x-126-e8d5d84edb5b1248.png",width: 126,height: 172}],
        src: "/_next/static/images/foam-finger@3x-126-e8d5d84edb5b1248.png",
        toString: function(){return "/_next/static/images/foam-finger@3x-126-e8d5d84edb5b1248.png"},
        
        width: 126,
        height: 172
      }